import { render, staticRenderFns } from "./AccountNotificationSettings.vue?vue&type=template&id=6ba8a56c&scoped=true"
import script from "./AccountNotificationSettings.vue?vue&type=script&lang=js"
export * from "./AccountNotificationSettings.vue?vue&type=script&lang=js"
import style0 from "./AccountNotificationSettings.vue?vue&type=style&index=0&id=6ba8a56c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba8a56c",
  null
  
)

export default component.exports